import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { currentTab, TAB_NAV } from './navigation';

/**
 * The bottom tab bar below 1024 px (style guide 2.10, S150-1, S170-1): Start,
 * Freigaben, Kalender, Beitraege and Mehr. A tab is current
 * for its own routes and their sub-routes; "Mehr" for every other area, so the
 * bar always shows where the user is.
 */
export function BottomTabs() {
  const { t } = useTranslation();
  const current = currentTab(useLocation().pathname);
  return (
    <nav className="ui-bottomnav ui-tabs-app" aria-label={t('shell.tabsLabel')}>
      {TAB_NAV.map(({ key, path, icon: Icon }) => (
        <Link
          key={key}
          to={path}
          className="ui-bottomnav__item"
          aria-current={current === key ? 'page' : undefined}
        >
          <span className="ui-bottomnav__icon">
            <Icon aria-hidden="true" size={20} />
          </span>
          {t(`nav.tab.${key}`)}
        </Link>
      ))}
    </nav>
  );
}
